import { flags, useFeatureFlags } from "../../../lib/feature-flags"

export const useLifelongLearningEnabled = () => {
  const [isEnabled = false] =
    useFeatureFlags([flags.FLAG_FEAT_LIFELONG_LEARNING_MEMBERSHIP_API]) ?? []
  return Boolean(isEnabled)
}
